import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pla-private-number-plates',
  templateUrl: './private-number-plates.component.html',
  styleUrls: ['./private-number-plates.component.scss']
})
export class PrivateNumberPlatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
